import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=5ab2f97f&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=5ab2f97f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2f97f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab2f97f')) {
      api.createRecord('5ab2f97f', component.options)
    } else {
      api.reload('5ab2f97f', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=5ab2f97f&scoped=true&", function () {
      api.rerender('5ab2f97f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qtxRESTzOewW/JS/comp/GuestBox.vue"
export default component.exports